import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'mrsoftapps-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  id: any;
  constructor() { }

 
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.id = setInterval(() => {
      
      const images = [
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/1.webp)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/2.jpg)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/3.jpg)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/4.jpg)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/5.jpg)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/6.jpg)',
        ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(../../assets/images/random/7.jpg)',
      ];

      const theChange = document.querySelector('.reference_holder') as HTMLElement;
      const change = images[Math.floor(Math.random() * images.length)];
      theChange.style.backgroundImage = change;
      theChange.style.transition = 'all 2000';

    }, 10000);
    
  }

  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    }
  }

}
